module.exports = __webpack_public_path__ + "assets/img/tab-cover5-32d9b55a.jpg";